import React from "react";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import TipoEntrega from "./helpers/TipoEntrega";
import ContentTable from "./ContentTable";
import Status from "./helpers/Status";
import { getCostString, getTimeStr, getTimeWithHourStr } from "./helpers";
import { getRowsAndTotal } from "../../state/order/actions";
import { getListOrigens, getLabelOrigem } from "../../main/origem";
import consts from "../../main/consts";
import LockIcon from "@material-ui/icons/Lock";
import { debounce } from "lodash";
import { salesChannelIsAmericanas } from "../../utils/check-sales-channel";
import { deliveryNumber } from "../../utils/fields/formatters";

const styles = (theme) => ({
  totalCost: {
    minWidth: 130,
    fontWeight: "bold",
  },
  maxWidthCol: {
    maxWidth: 170,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "inherit",
    },
  },
  capitalize: {
    textTransform: "capitalize",
  },
});

const getHeaders = (classes) => [
  {
    title: "Nº Pedido",
    align: "left",
    dataField: "codigoExterno",
    class: classes.maxWidthCol,
    render: (codigoExterno) => codigoExterno.split("#")[0],
  },
  {
    title: "Nº Entrega",
    align: "left",
    dataField: "entregas",
    class: classes.maxWidthCol,
    render: (entregas) => deliveryNumber(entregas[entregas.length - 1].codigo),
  },
  {
    title: "Origem",
    align: "left",
    dataField: "origem",
    filter: "origem",
    filterOptions: getListOrigens(),
    render: (data) => getLabelOrigem(data),
  },
  {
    title: "Data",
    align: "left",
    dataField: "dataInclusao",
    render: (data) => new Date(data).toLocaleDateString(),
  },
  {
    title: "Entrega estimada",
    align: "left",
    dataField: "dhEntregaEstimada",
    render: (data, row) => salesChannelIsAmericanas(row.canalDeVendas) ? getTimeStr(data) : getTimeWithHourStr(data),
  },
  {
    title: "Cliente",
    align: "left",
    dataField: "cliente",
    class: classes.capitalize,
    render: (data) => data && data.nome.toLowerCase(),
  },
  {
    title: "Canal de venda",
    align: "left",
    dataField: "canalDeVendas",
    render: (data) => data,
  },
  {
    title: "Associado",
    align: "left",
    dataField: "associado",
    class: classes.capitalize,
    render: (data) => data && data.nome.toLowerCase(),
  },
  {
    title: "Tipo de Entrega",
    align: "left",
    dataField: "tipoEntrega",
    render: (data) => (
      <TipoEntrega tipoEntrega={data} aguardandoRetirada={true} />
    ),
  },
  {
    title: "Status",
    align: "center",
    dataField: "status",
    render: (data) => <Status status={data} />,
  },
  {
    title: "Total",
    align: "right",
    dataField: "valorTotal",
    class: classes.totalCost,
    render: (val, { origem }) =>
      origem === "PEGUE_NA_LOJA" ? (
        <LockIcon style={{ color: "#0000008a" }} />
      ) : (
        getCostString(val)
      ),
  },
];

const PAGE_NAME = "history";
const ROWS_PER_PAGE = consts.ROWS_PER_PAGE;

class Historico extends React.Component {
  state = {
    status: "FINALIZADO,CANCELADO,DEVOLVIDO",
    dataInicial: null,
    dataFinal: null,
    order: null,
    orderBy: null,
    find: "",
  };

  componentDidMount() {
    this.loadGridData(0, ROWS_PER_PAGE, true);
  }

  componentDidUpdate(prevProps) {
    const {
      loja,
      orders: { filters },
      limit,
    } = this.props;

    if (
      loja !== prevProps.loja ||
      filters !== prevProps.orders.filters ||
      prevProps.limit !== limit
    ) {
      this.loadGridData(0, ROWS_PER_PAGE, true);
    }
  }

  loadGridData = (page, limits, avoidSpinner = false) => {
    const {
      getRowsAndTotal,
      orders: { filters },
      limit,
    } = this.props;
    const { order, orderBy, ...stateFilters } = this.state;

    if (order && orderBy) {
      stateFilters[orderBy] = order;
    }
    limits = limits || ROWS_PER_PAGE;

    getRowsAndTotal({
      page,
      limit: limit,
      filters: { ...filters, ...stateFilters },
      avoidSpinner,
      pageId: PAGE_NAME,
    });
  };

  clickRow = (row) => {
    this.props.history.push(`${consts.CONTEXT}/history/${row.numero}`, {
      data: { page: PAGE_NAME },
    });
  };

  handleOrderChange = (ordering) => {
    this.setState({ order: ordering.order, orderBy: ordering.orderBy }, () =>
      this.loadGridData(0, null, true)
    );
  };

  handleFilterChange = debounce((find) => {
    this.setState({ find }, () => {
      (find.length >= 3 || find.length === 0) &&
        this.loadGridData(0, null, true);
    });
  }, 600);

  handleDateChange = (e) => {
    const { _d: date } = e || {};
    if (!date || !isNaN(date)) {
      this.setState({ dataInicial: date, dataFinal: date }, () =>
        this.loadGridData(0, null, {}, true)
      );
    }
  };

  render() {
    const { dataInicial, find } = this.state;

    return (
      <ContentTable
        loaded={this.props.orders.loaded}
        limit={this.props.limit}
        title="Histórico"
        subtitle="Os pedidos sempre ficam registrados."
        page={PAGE_NAME}
        headers={getHeaders(this.props.classes)}
        onClickRow={this.clickRow}
        rows={this.props.orders.grids[PAGE_NAME].rows}
        total={this.props.orders.grids[PAGE_NAME].total}
        selectedPage={this.props.orders.page}
        rowsPerPage={ROWS_PER_PAGE}
        showPaginator={false}
        onHandlePageChange={this.loadGridData}
        filter={{
          enable: true,
          dataInicial,
          find,
          handleOrderChange: this.handleOrderChange,
          handleFilterChange: this.handleFilterChange,
          handleDateChange: this.handleDateChange,
        }}
        selectedOrigemFilter={getLabelOrigem(
          this.props.orders.grids[PAGE_NAME].selectedFilter
        )}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    loja: state.auth.loja,
    limit: state.orders.limit,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getRowsAndTotal }, dispatch);
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Historico);
